/* eslint-disable react/jsx-props-no-spreading, max-len */
import Icon from '../components/Icon'
import categories from './categories'

function Temple(props) {
  return (
    <Icon {...props}>
      <rect height="7" width="3" x="4" y="10" />
      <rect height="7" width="3" x="10.5" y="10" />
      <rect height="3" width="20" x="2" y="19" />
      <rect height="7" width="3" x="17" y="10" />
      <polygon points="12,1 2,6 2,8 22,8 22,6" />
    </Icon>
  )
}

Temple.tags = ['Customers']
Temple.category = categories.users

export default Temple
